// extracted by mini-css-extract-plugin
export var cartContainer = "_pj-4";
export var gray = "_pj-1";
export var itemContainer = "_pj-2";
export var itemDetails = "_pj-3";
export var strong = "_pj-0";